import { connect } from 'react-redux';
import { performTripadvisorSearch, selectTripadvisorIsSearching } from '../redux/tripadvisorSlice';
import '../styles/LoadingAnimation.css';

const TripadvisorSearch = ({ 
  value, 
  onChange, 
  category, 
  dispatch, 
  isSearching, 
  isReadOnly = false,
  disabled = false,
  onSearch 
}) => {
  
  const handleTripadvisorSearch = () => {
    if (value && category) {
      console.log('Searching TripAdvisor with:', { query: value, category });
      
      if (onSearch) {
        onSearch(value);
      }
      
      dispatch(performTripadvisorSearch(value, category));
    } else {
      console.error('Cannot search: Missing value or category', { value, category });
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && !disabled && !isSearching) {
      event.preventDefault();
      handleTripadvisorSearch();
    }
  };

  return (
    <div className="tripadvisor-search-container" style={{ display: 'flex', gap: '10px', alignItems: 'stretch' }}>
      <input 
        type="text" 
        value={value || ''} 
        onChange={(e) => !disabled && onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        readOnly={isReadOnly || disabled}
        disabled={disabled}
        style={{ 
          flexGrow: 1,
          padding: '8px',
          fontSize: '18px',
          lineHeight: '1.5',
          height: '42px',
          boxSizing: 'border-box',
          border: '1px solid #ccc',
          borderRadius: '5px',
          opacity: disabled ? 0.6 : 1,
          cursor: disabled ? 'not-allowed' : 'text'
        }} 
        placeholder="Enter search term"
      />
      <button 
        type="button" 
        onClick={handleTripadvisorSearch}
        disabled={isSearching || !value || disabled}
        style={{ 
          padding: '8px 16px', 
          cursor: isSearching || !value || disabled ? 'not-allowed' : 'pointer',
          fontSize: '18px',
          lineHeight: '1.5',
          minWidth: '100px',
          height: '42px',
          boxSizing: 'border-box',
          border: '1px solid #ccc',
          borderRadius: '5px',
          backgroundColor: isSearching || !value ? '#ccc' : '#123195',
          color: 'white',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        {isSearching ? (
          <div className="loading-circle" style={{ 
            width: '16px', 
            height: '16px',
            margin: '0',
            borderWidth: '2px'
          }}></div>
        ) : 'Search'}
      </button>
    </div>
  );
};

const mapStateToProps = (state) => ({
  isSearching: selectTripadvisorIsSearching(state)
});

export default connect(mapStateToProps)(TripadvisorSearch);
